import { cn } from "@lib/cn";
import type { KeyboardEvent } from "react";

interface Props {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: "text" | "number" | "url";
  invalid?: boolean;
  /**
   * Focus on mount. Only the popover hosts pass this — the version form's
   * rows must never steal focus from each other.
   */
  autoFocus?: boolean;
  /**
   * Key handling for hosts with their own commit/cancel keys (the editor's
   * value popover saves on Enter and closes on Escape). Omitted in the
   * version form, where the form owns submission.
   */
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
}

export const ScalarControl = ({
  value,
  onChange,
  placeholder = "Enter value",
  type = "text",
  invalid = false,
  autoFocus = false,
  onKeyDown,
}: Props) => (
  <input
    type={type === "number" ? "text" : type}
    inputMode={type === "number" ? "decimal" : undefined}
    value={value}
    onChange={(event) => onChange(event.target.value)}
    onKeyDown={onKeyDown}
    // biome-ignore lint/a11y/noAutofocus: opt-in, only used by the value popover that opens on an explicit click
    autoFocus={autoFocus}
    placeholder={placeholder}
    className={cn(
      "tw-h-9 tw-w-full tw-rounded-lg tw-border tw-border-solid tw-border-transparent tw-bg-white tw-px-2 tw-text-sm tw-font-normal tw-text-blue tw-outline-none placeholder:tw-text-blue-500 focus:tw-border-primary focus:tw-bg-[#f2f0ff]",
      invalid && "tw-border-[#D43548] tw-bg-[#FAF1F2]",
    )}
  />
);
